







import {Vue, Component} from 'vue-property-decorator';

@Component({
    name: 'BackHomeButton',
})
export default class BackHomeButton extends Vue {

}
